import { queryClient } from 'index';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { LogyxError, getToastErrorMessage } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { toggleOrderBuyerModel } from 'services/BuyerModelsService';

interface IToggleOrderBuyerModelInternallyDTO {
  modelId: number;
  canOrderInternally: boolean;
}

export const useToggleOrderBuyerModelInternally = () => {
  const { t } = useTranslation();
  return useMutation(
    (dto: IToggleOrderBuyerModelInternallyDTO) => {
      return toggleOrderBuyerModel(
        dto.modelId,
        dto.canOrderInternally,
        undefined
      );
    },
    {
      onSuccess: (_data, variables) => {
        toast.success(
          variables.canOrderInternally
            ? t('Enabled internal ordering')
            : t('Disabled internal ordering')
        );
        queryClient.invalidateQueries([ReactQueryKeys.GET_BUYER_MODELS]);
      },
      onError: (error: LogyxError) => {
        toast.error(getToastErrorMessage(error));
      },
      mutationKey: ReactMutationKeys.TOGGLE_ORDER_BUYER_MODEL_INTERNALLY,
    }
  );
};

interface IToggleOrderBuyerModelExternallyDTO {
  modelId: number;
  canOrderExternally: boolean;
}

export const useToggleOrderBuyerModelExternally = () => {
  const { t } = useTranslation();
  return useMutation(
    (dto: IToggleOrderBuyerModelExternallyDTO) => {
      return toggleOrderBuyerModel(
        dto.modelId,
        undefined,
        dto.canOrderExternally
      );
    },
    {
      onSuccess: (_data, variables) => {
        toast.success(
          variables.canOrderExternally
            ? t('Enabled external ordering')
            : t('Disabled external ordering')
        );
        queryClient.invalidateQueries([ReactQueryKeys.GET_BUYER_MODELS]);
      },
      onError: (error: LogyxError) => {
        toast.error(getToastErrorMessage(error));
      },
      mutationKey: ReactMutationKeys.TOGGLE_ORDER_BUYER_MODEL_EXTERNALLY,
    }
  );
};
